// Wrap the code in a DOMContentLoaded event listener to ensure all elements are available
document.addEventListener('DOMContentLoaded', function () {
  // Check if the custom element has already been defined
  if (!customElements.get('localization-form')) {
    // Define the LocalizationForm class
    customElements.define('localization-form', class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        // Bind the event listeners to the class instance
        this.openSelector = this.openSelector.bind(this);
        this.closeSelector = this.closeSelector.bind(this);
        this.onContainerKeyUp = this.onContainerKeyUp.bind(this);
        this.onItemClick = this.onItemClick.bind(this);
      }

      connectedCallback() {
        // Add event listeners
        this.elements.button.addEventListener('click', this.openSelector);
        this.elements.button.addEventListener('focusout', this.closeSelector);
        this.addEventListener('keyup', this.onContainerKeyUp);
        this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick));
      }

      disconnectedCallback() {
        // Remove event listeners
        this.elements.button.removeEventListener('click', this.openSelector);
        this.elements.button.removeEventListener('focusout', this.closeSelector);
        this.removeEventListener('keyup', this.onContainerKeyUp);
        this.querySelectorAll('a').forEach(item => item.removeEventListener('click', this.onItemClick));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        this.hidePanel();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
      }

      closeSelector(event) {
        const isChild = this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    });
  }

  const countryBtn = document.querySelectorAll('.country_link');

  countryBtn.forEach(function(btn){
    btn.addEventListener('click', function(){
      btn.closest('form').submit();
    })
  })
});
